import { useQuery } from '@tanstack/react-query';
import { getApiV1Modelareatype } from '../api/generated';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchModelAreas = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.modelAreaTypes(),
    queryFn: () => getApiV1Modelareatype(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
